import { templates as templates$1 } from "../locales/en.js";
import { enTemplates } from "@progressive-development/pd-page";
import { enTemplates as enTemplates$1 } from "@progressive-development/pd-dialog";
import { enTemplates as enTemplates$2 } from "@progressive-development/pd-wizard";
import { enTemplates as enTemplates$3 } from "@progressive-development/pd-content";
import { enTemplates as enTemplates$4 } from "@progressive-development/pd-forms";
import { enTemplates as enTemplates$5 } from "@progressive-development/pd-order";
//#region src/generated/locale-wrapper/en-wrapper.ts
var templates = {
	...templates$1,
	...enTemplates$1,
	...enTemplates$5,
	...enTemplates$2,
	...enTemplates,
	...enTemplates$3,
	...enTemplates$4
};
//#endregion
export { templates };
